import { Base } from "../../framework/base";
import { CompanyMenuItem } from "../company/companyMenuItem";
import { InstantMessageChannelEditItem } from "./instantMessageChannelEditItem";
import { InstantMessageChannelEditUserItem } from "./instantMessageChannelUserEditItem";
var InstantMessageChannelEdit = /** @class */ (function () {
    function InstantMessageChannelEdit(obj) {
        this.userIsInstantMessageChannelAdmin = obj && obj.userIsInstantMessageChannelAdmin || false;
        this.instantMessageChannel = new InstantMessageChannelEditItem(obj ? obj.instantMessageChannel : null);
        this.companies = Base.getTypedArray(obj ? obj.companies : null, CompanyMenuItem);
        this.users = Base.getTypedArray(obj ? obj.users : null, InstantMessageChannelEditUserItem);
        this.archivingRemoveDate = obj && obj.archivingRemoveDate || 0;
    }
    return InstantMessageChannelEdit;
}());
export { InstantMessageChannelEdit };
